import { render, staticRenderFns } from "./FuWuLocation.vue?vue&type=template&id=1947bef5&"
import script from "./FuWuLocation.vue?vue&type=script&lang=ts&"
export * from "./FuWuLocation.vue?vue&type=script&lang=ts&"
import style0 from "./FuWuLocation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports